import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bd95a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title_filtros" }, "Filtrar por:", -1))
const _hoisted_2 = { class: "box_wrapper" }
const _hoisted_3 = { class: "filtros_footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_box_filter = _resolveComponent("box-filter")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, { width: "auto" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "filtros_wrapper" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtros, (filtro, index) => {
              return (_openBlock(), _createBlock(_component_box_filter, {
                key: index,
                filtro: filtro
              }, null, 8, ["filtro"]))
            }), 128))
          ]),
          _createElementVNode("footer", _hoisted_3, [
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelar())),
              class: "btn_action_filter"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancelar")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.aplicar())),
              class: "btn_action_filter"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Aplicar")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}